import useTranslation from 'next-translate/useTranslation';
import Loading from 'components/shared/Loading/Loading';

const EmailCheckDisplay = () => {
  const { t } = useTranslation('common');
  return (
    <>
      <div className='title'>{t('email_check_display.verifying_your_email')}</div>
      <div className='subtitle' style={{ marginTop: 30 }}>
        {t('email_check_display.checking_body')}
      </div>
      <Loading text={t('email_check_display.verifying')} />
    </>
  );
};

export default EmailCheckDisplay;
